@if (contribution) {
  <div class="page-content-smallMargin page-fill">
    <div class="d-flex flex-row" style="height: 50px; padding-top: 15px">
      <!-- <div class="row" style="padding-top: 15px"> -->
      <dx-select-box [placeholder]="'Month to Reconcile'" [items]="months" [(value)]="selectedMonthId" valueExpr="id" displayExpr="name" tabindex="-1"></dx-select-box>
      <button type="button" class="btn btn-sm btn-success ms-4" (click)="getData()" [disabled]="processing">Get Data</button>
      <!-- <div class="ms-4 me-2 center-items">Total Clover Amount</div>
      <dx-number-box style="max-width: 75px" [(value)]="cloverTotal" format="#,##0.00;(#,##0.00)"></dx-number-box> -->
      <div class="ms-4 me-2 center-items">Fee Amount</div>
      <dx-number-box style="max-width: 75px" [(value)]="fee" format="#,##0.00;(#,##0.00)"></dx-number-box>
      <!-- <button type="button" class="btn btn-primary ms-4" (click)="save()" [disabled]="processing">Create Batches</button> -->
      <button type="button" class="btn btn-primary ms-4" (click)="serverSide()" [disabled]="processing">Create Batches Server</button>
      <button type="button" class="btn btn-secondary ms-2" (click)="cancel()" [disabled]="processing">Cancel</button>
      <button type="button" class="btn btn-danger ms-5" (click)="delete()" [disabled]="processing || (bankAmounts.length === 0 && contributions.length === 0)">Clear Data</button>
      <button type="button" class="btn btn-secondary ms-5" (click)="summary()" [disabled]="processing || (bankAmounts.length === 0 && contributions.length === 0)">Show Summary</button>
    <!-- </div> -->
  </div>
  @if (contribution) {
    <div class="flex-fill d-flex flex-row pt-3">
      <div class="col-sm-5 pe-3 d-flex flex-column">
        <div>
          <h2 style="text-align: center">Bank Amounts</h2>
        </div>
        <div>
          @if (true) {
            <dx-file-uploader
              class="online-uploader"
              selectButtonText="Select"
              [multiple]="true"
              xlabelText=""
              accept="*"
              [uploadMode]="'instantly'"
              (onUploadStarted)="uploadStarted()"
              (onUploaded)="attachmentUploaded('Bank')"
              [uploadUrl]="serviceName + '/api/utility/uploadBankAmounts/'"
              [uploadHeaders]="uploadHeaders"
              >
            </dx-file-uploader>
          }
        </div>
        <!-- <div class="row"> -->
        <!-- <dx-form class="mb-3" [formData]="bankEntry" [colCount]="1">
        <dxi-item #bankSelect dataField="amount" [editorOptions]="{ placeholder: '$0.00' }"></dxi-item>
      </dx-form> -->
      <div class="grid-fill">
        <dx-data-grid
          #bankGrid
          class="lines-grid pe-2"
          [keyExpr]="'id'"
          [dataSource]="bankAmounts"
          (onToolbarPreparing)="onToolbarPreparingBank($event)"
          (onSelectionChanged)="onSelectionChange($event)"
          (onRowPrepared)="rowPrepareBank($event)"
          (onRowDblClick)="bankRowDoubleClick($event)"
          [focusedRowEnabled]="false"
          [showBorders]="true"
          >
          <dxi-column dataField="id" caption="Id" width="60" cssClass="align-right-pad"></dxi-column>
          <dxi-column dataField="postDate" caption="Date" type="date" format="shortDate" width="100"></dxi-column>
          <dxi-column dataField="description" caption="Description" width="275"></dxi-column>
          <dxi-column dataField="amount" dataType="number" [format]="{ type: 'currency', precision: 2 }" width="110" cssClass="align-right-pad"></dxi-column>
          <dxi-column dataField="contributionList" caption="Links" width="75"></dxi-column>
          <dxi-column dataField="" width="25"></dxi-column>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button type="button" (click)="processBankCSV()" class="btn btn-sm btn-secondary" [disabled]="!bankPath">Process CSV Data</button>
            <button type="button" (click)="link()" class="btn btn-sm btn-primary ms-5" [disabled]="bankGrid.instance.getSelectedRowsData().length !== 1">Link</button>
            <button type="button" (click)="unLink()" class="btn btn-sm btn-danger ms-5" [disabled]="bankGrid.instance.getSelectedRowsData().length !== 1">
              UnLink
            </button>
          </div>
          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <dxo-selection [mode]="'multiple'"></dxo-selection>
          <dxo-summary>
            <dxi-total-item column="description" summaryType="count" displayFormat="Count: {0}"> </dxi-total-item>
            <dxi-total-item column="amount" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }" displayFormat="Sum: {0}"> </dxi-total-item>
          </dxo-summary>
        </dx-data-grid>
      <!-- </div> -->
    </div>
  </div>
  <div class="col-sm-7 pe-4 d-flex flex-column">
    <div>
      <h2 style="text-align: center">Clover Giving</h2>
    </div>
    <div>
      @if (true) {
        <dx-file-uploader
          class="online-uploader"
          selectButtonText="Select"
          [multiple]="true"
          xlabelText=""
          accept="*"
          [uploadMode]="'instantly'"
          (onUploadStarted)="uploadStarted()"
          (onUploaded)="attachmentUploaded('Clover')"
          [uploadUrl]="serviceName + '/api/utility/uploadOnlineGiving/'"
          [uploadHeaders]="uploadHeaders"
          >
        </dx-file-uploader>
      }
    </div>
    <!-- <div class="row"> -->
    <!-- <dx-form class="mb-3" [formData]="contribution" validationGroup="statusChangeData" [colCount]="2">
    <dxi-item [label]="{ text: 'Box #' }">
      <div *dxTemplate>
        <dx-text-box #personSelect [(value)]="contribution.envelope" (onValueChanged)="envelopeChanged($event)"></dx-text-box>
      </div>
    </dxi-item>
    <dxi-item
      #personSelect
      dataField="personId"
      [colSpan]="2"
      [label]="{ text: 'Person' }"
      editorType="dxSelectBox"
                            [editorOptions]="{
                                items: people,
                                valueExpr: 'id',
                                displayExpr: 'name',
                                searchEnabled: true,
                                searchMode: 'contains',
                                tabIndex: -1
                            }"
    ></dxi-item>
    <dxi-item dataField="amount" [editorOptions]="{ placeholder: '$0.00' }"></dxi-item>
    <dxi-item dataField="note" [editorOptions]="{ tabIndex: -1 }"></dxi-item>
  </dx-form> -->
  <div class="grid-fill">
    <dx-data-grid
      #contributionsGrid
      class="lines-grid"
      [keyExpr]="'id'"
      [dataSource]="contributions"
      [columnAutoWidth]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onSelectionChanged)="onSelectionChange($event)"
      (onRowPrepared)="rowPrepare($event)"
      [focusedRowEnabled]="false"
      [showBorders]="true"
      >
      <dxi-column dataField="donationDate" caption="Date" width="100" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column dataField="donorName" dataType="text" caption="Name" width="155" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column dataField="donorId" caption="DonorId" width="100" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column dataField="personId" caption="PersonId" width="100" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column dataField="batchId" caption="Batch" width="100" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column
        dataField="grossGift"
        dataType="number"
        [format]="{ type: 'currency', precision: 2 }"
        cssClass="align-right-pad"
        cellTemplate="colorTemplate"
      ></dxi-column>
      <dxi-column dataField="bankTransactionId" caption="Link Id" width="75" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column width="30"></dxi-column>
      <dxi-column dataField="fund" width="75" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column dataField="contributionId" caption="ArkId" width="75" cellTemplate="colorTemplate"></dxi-column>
      <dxi-column width="100"></dxi-column>
      <div *dxTemplate="let data of 'toolbarButtons'">
        <button (click)="assignPerson()" class="btn btn-sm btn-danger" accesskey="a" [disabled]="contributionsGrid.instance.getSelectedRowsData().length !== 1">
          Assign Person
        </button>
        <button (click)="setMonth('current')" class="btn btn-sm btn-success ms-4">Current Month</button>
        <button (click)="setMonth('next')" class="btn btn-sm btn-primary">Next Month</button>
        <button (click)="processGivingCSV()" class="btn btn-sm btn-secondary ms-4" [disabled]="!givingPath">Process CSV Data</button>
        <button (click)="autoAssign()" class="btn btn-sm btn-secondary ms-4" [hidden]="!canDelete" >AutoAssign</button>
        <button (click)="deleteContribution()" class="btn btn-sm btn-danger ms-4" [hidden]="!canDelete" >delete</button>
        <button class="btn btn-sm btn-danger ms-2" (click)="save(true)" [hidden]=" !autoAssignComplete" >Save</button>
      </div>
      <div *dxTemplate="let cell of 'colorTemplate'">
        <div class="{{ cell.data.nextMonth && !cell.data.contributionId ? 'nextMonth' : cell.data.nextMonth && !!cell.data.contributionId ? 'lastMonth' : '' }}">
          {{ cell.text }}
        </div>
      </div>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
      <dxo-summary>
        <dxi-total-item column="grossGift" summaryType="sum" [valueFormat]="{ type: 'currency', precision: 2 }" displayFormat="Sum: {0}"> </dxi-total-item>
      </dxo-summary>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (contributions) {
          <span class="me-3"
            ><strong>{{ 'Selected ' + (selectedSum | currency) }}</strong></span
            >
          }
        </div>
      </dx-data-grid>
    </div>
  </div>
</div>
}
</div>
}
